export const LEAVE_FEEDBACK_QUERY = 'leaveFeedback';

export const REVIEWS_LEAVE_FEEDBACK_LINK = `/reviews?${LEAVE_FEEDBACK_QUERY}=1`;
